/**
 * 30-minute `HH:mm` slots, 00:00 → 23:30. Used by every component that needs
 * to render a time-of-day select (BookingDateTime, SearchFilterBlock).
 */
export const TIME_OPTIONS: string[] = Array.from({ length: 48 }, (_, i) => {
  const h = Math.floor(i / 2).toString().padStart(2, "0");
  const m = i % 2 === 0 ? "00" : "30";
  return `${h}:${m}`;
});

function isSameCalendarDay(a: Date, b: Date): boolean {
  return (
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate()
  );
}

/**
 * Time slots valid for a pickup/return on `date`. When `date` is today, slots
 * at or before the current wall-clock time are dropped — you can't book a
 * pickup in the past. For any future date (or `undefined`) every slot is
 * returned. Comparison is done in the browser's local timezone, matching how
 * the calendar decides "today".
 */
export function availableTimeOptions(
  date: Date | undefined,
  now: Date = new Date(),
): string[] {
  if (!date || !isSameCalendarDay(date, now)) return TIME_OPTIONS;
  const nowMinutes = now.getHours() * 60 + now.getMinutes();
  return TIME_OPTIONS.filter((t) => {
    const [h, m] = t.split(":").map(Number);
    return h * 60 + m > nowMinutes;
  });
}
